import React from "react";
import ContactFormComponent from "../components/ContactFormComponent";
import usePageMeta from "../hooks/usePageMeta";
import useScrollReveal from "../hooks/useScrollReveal";
import { buildApiUrl } from "../utils/api";

function ContactForm() {
  usePageMeta({
    title: "Contact",
    description: "Formulaire de contact de Sofiane Amroune, développeur web sénior.",
  });

  const { ref: titleRef, revealProps: titleRevealProps } = useScrollReveal({
    triggerOnce: true,
    threshold: 0.2,
  });

  const { ref: formRef, revealProps: formRevealProps } = useScrollReveal({
    triggerOnce: true,
    threshold: 0.12,
  });

  return (
    <div className="page-shell space-y-8 lg:space-y-10">
      <section
        ref={titleRef}
        {...titleRevealProps}
        className="hero-panel scroll-reveal text-center"
      >
        <span className="eyebrow">Contact</span>
        <h1>Contactez-moi</h1>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-8 text-muted sm:text-xl">
          Vous pouvez me laisser un message via ce formulaire.
        </p>
      </section>

      <section
        ref={formRef}
        {...formRevealProps}
        className="scroll-reveal"
      >
        <div className="mx-auto max-w-4xl">
          <ContactFormComponent endpoint={buildApiUrl("/contact")} />
        </div>
      </section>
    </div>
  );
}

export default ContactForm;
